import { render } from "./PageViewIsiBerasa.vue?vue&type=template&id=955c2dba"
import script from "./PageViewIsiBerasa.vue?vue&type=script&lang=js"
export * from "./PageViewIsiBerasa.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__